import React, { PureComponent } from "react";
import styled from "styled-components";
import projectList from "../../data/projectInformation";
import { typo } from "../../styles/style";
import ImgHeightAtom from "../atoms/ImgHeightAtom";
import PlusButtonAtom from "../atoms/PlusButtonAtom";
import TextMaxWidthAtom from "../atoms/TextMaxWidthAtom";

const ProjectCardOuter = styled.div`
  display: flex;
  justify-content: ${(props) => props.justifyContent || "center"};
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0%;
  align-items: ${(props) => props.alignItem};
  border-radius: ${(props) => props.borderRadius};
  flex-wrap: wrap;

`;

const ProjectCardLayoutBox = styled.div`
  display: flex;
  width: 80%;
  height: 100%;
  max-height:  580px;
  background: ${(props) => props.background};
  justify-content: space-around;
  border-radius: 30px;
  margin-bottom: 120px;
`

const ProjectCardFlexBox = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
`
const ProjectCardTextBox = styled.div`
  display: flex;
  width: 40%;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  padding-left: 10%;
  ${({ theme }) => theme.media.tablet`
    `}
  ${({ theme }) => theme.media.mobile`
    width: 100%;
    padding: 0;
    align-items: center;
    `}
`;

const ProjectCardImgBox = styled.div`
  display: flex;
  width: 60%;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${({ theme }) => theme.media.tablet`
    `}
  ${({ theme }) => theme.media.mobile`
  display: none;
    `}
`;

const BorderBottom = styled.div`
  display: block;
  width: 71px;
  border-bottom: ${(props) => props.borderBottom || "2px solid #0c0c0c"};

  ${({ theme }) => theme.media.mobile`
  display: none;
    `}
`;

export class ProjectInformationMolecule extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <ProjectCardLayoutBox background={this.props.background}>
        <ProjectCardTextBox>
          <ProjectCardFlexBox>
            <TextMaxWidthAtom
              text={this.props.title}
              typo={this.props.titleTypo}
              color={this.props.titleColor}
            />
          </ProjectCardFlexBox>
          <ProjectCardFlexBox>
            <TextMaxWidthAtom
              text={this.props.firsttext}
              typo={this.props.textTypo}
              color={this.props.textColor}
              lineHeight="40.54px"
            />
            <TextMaxWidthAtom
              text={this.props.secondtext}
              typo={this.props.textTypo}
              color={this.props.textColor}
              lineHeight="40.54px"
            />
          </ProjectCardFlexBox>
          <ProjectCardFlexBox>
            <PlusButtonAtom 
              color={this.props.buttonColor}
              border={this.props.buttonBorder}
            />
          </ProjectCardFlexBox>
          <ProjectCardFlexBox>
            <BorderBottom 
            borderBottom ={this.props.borderBottom}
            />
          </ProjectCardFlexBox>
        </ProjectCardTextBox>
        <ProjectCardImgBox>
          <ImgHeightAtom src= {this.props.img}  top={this.props.top} width={this.props.width}/>
        </ProjectCardImgBox>
      </ProjectCardLayoutBox>
    );
  }
}

class ProjectInformationMolecules extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  projectCard = (projectList) => {
    return projectList.map((project,index) => {
      return (
        <ProjectInformationMolecule
          background={project.backgroundcolor}
          title={project.name}
          titleTypo={typo.body.b3}
          titleColor={project.color}
          buttonColor={project.color}
          buttonBorder={project.border}
          borderBottom={project.borderBottom}
          width={project.width}
          top={project.imgtop}
          firsttext={project.firsttext}
          secondtext={project.secondtext}
          textTypo={typo.body.b4}
          textColor={project.color}
          img={project.image}
          key={index}
        />
      );
    });
  };

  render() {
    const projectsCard = this.projectCard(projectList);
    return (
      <ProjectCardOuter id={this.props.id}>{projectsCard}</ProjectCardOuter>
    );
  }
}

export default ProjectInformationMolecules;
